/**
 * @name linux.constants
 * @description Core linux.constants in ngx-responsive
 *
 * @license MIT
 */
import { ILinuxOS } from '../interfaces';

export const LINUX_OS: ILinuxOS = {
    DEBIAN: 'Debian',
    KNOPPIX: 'Knoppix',
    MINT: 'Mint',
    UBUNTU: 'Ubuntu',
    KUBUNTU: 'Kubuntu',
    XUBUNTU: 'Xubuntu',
    LUBUNTU: 'Lubuntu',
    FEDORA: 'Fedora',
    RED_HAT: 'Red hat',
    MANDRIVA: 'Mandriva',
    GENTOO: 'Gentoo',
    SABAYON: 'Sabayon',
    SLACKWARE: 'Slackware',
    SUSE: 'Suse',
    CENT_OS: 'CentOS',
    BACKTRACK: 'Backtrack',
    GENERIC_LINUX: 'Generic Linux'
};
